const privacyData = {
  hero: {
    title: "Privacy Policy",
    subtitle: "Buy & Sell Used Cars Safely"
  },

  sections: {
    intro: {
      title: "Introduction",
      paragraphs: [
        "Welcome to CarZone. We are committed to protecting your privacy while you buy or sell used cars on our platform. This policy explains how we collect, use, and safeguard your personal and vehicle information.",
        "By using our services such as listing a vehicle, contacting sellers, or requesting valuations, you agree to the practices described in this Privacy Policy."
      ]
    },

    collection: {
      title: "Data Collection",
      intro: "We collect information to provide safe and efficient car transactions.",
      list: [
        "Name, phone number, email address",
        "Vehicle registration & ownership details",
        "Car specifications, price & location",
        "Uploaded photos and documents",
        "Communication between buyers and sellers"
      ]
    },

    types: {
      title: "Types of Data",
      list: [
        "Personal Data: identity and contact information",
        "Vehicle Data: model, year, mileage, condition",
        "Listing Data: price, images, description",
        "Usage Data: pages visited, search filters",
        "Device Data: browser, IP address, location"
      ]
    },

    use: {
      title: "Use of Data",
      list: [
        "Publish and promote your car listings",
        "Connect buyers with sellers",
        "Enable calls and enquiries",
        "Provide price valuation insights",
        "Improve search & recommendations",
        "Prevent fraud and fake listings",
        "Customer support & dispute resolution"
      ]
    },

    third: {
      title: "Third-Party Services",
      intro: "We may share limited data with trusted partners:",
      list: [
        "Payment gateways for premium listings",
        "Analytics providers to improve platform",
        "Cloud storage for vehicle images",
        "Verification services for ownership checks"
      ],
      note: "We never sell your personal data to advertisers or unrelated third parties."
    },

    rights: {
      title: "User Rights",
      list: [
        "Edit or update your car listings anytime",
        "Delete vehicle photos or information",
        "Deactivate or delete your account",
        "Request removal of personal data",
        "Opt-out of promotional communication"
      ]
    },

    security: {
      title: "Security",
      list: [
        "Encrypted HTTPS connections",
        "Secure cloud storage",
        "Access-controlled databases",
        "Fraud detection monitoring",
        "Regular security updates"
      ],
      note:
        "While we take strong measures, no online platform can guarantee absolute security. Users should avoid sharing sensitive financial data directly with unknown buyers or sellers."
    },

    contact: {
      title: "Contact",
      intro:
        "For privacy concerns, data removal requests, or listing issues:",
      email: "support@carzone.com",
      phone: "+91 98765 43210",
      address: "Madurai, Tamil Nadu, India"
    }
  }
};

export default privacyData;